import { useQueryApi, handleCommonErrors } from 'utils/api'
import { validateStatus } from 'api/kinerja/pengawas-sekolah/config'
import { apiPaths, queryKeys } from './config'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { NotFoundError } from 'utils/customError'

import type { ResponseGetPenetapanSummary } from 'types/kinerja-ps-pegawai'
import type { UseQueryOptions } from 'react-query'

function handleError(status, path, error) {
  if (status >= 400 && status <= 500) {
    throw new NotFoundError(path, error)
  } else {
    handleCommonErrors(status, path, error)
  }
}

export function useAPIGetPenetapanSummary({
  options,
}: {
  options?: UseQueryOptions<ResponseGetPenetapanSummary>
}) {
  const { period } = usePeriodContext()
  return useQueryApi<ResponseGetPenetapanSummary>(
    `${apiPaths.penetapan(period.id)}/summary`,
    {
      queryKey: [
        queryKeys.API_GET_PENETAPAN_SUMMARY,
        {
          period: period.id,
        },
      ],
      axiosConfig: {
        validateStatus,
      },
      queryConfig: {
        useErrorBoundary: true,
        ...options,
      },
      errorHandlerFn: handleError,
    }
  )
}
